





























































































































































import Vue from 'vue';
import { get } from 'lodash';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import AddCustomerFormModal from '@/web/components/customers/AddCustomerFormModal.vue';
import SendInvitationEmailsModal from '@/web/components/customers/SendInvitationEmailsModal.vue';
import Status from '@/web/components/customers/Status.vue';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters, mapState } from 'vuex';
import { getConfig } from '@/web/utils/configuration';
import CustomerNotesModal from '@/web/components/customers/CustomerNotesModal.vue';

interface LocalForm {
  search: string;
  selectedStatus: boolean | null | undefined;
  selectedProduct: string | null | undefined;
}

interface LocalState {
  date: DatePicker;
  statuses: Array<any>;
  tableFields: Array<any>;
  formLoaded: boolean;
  form: LocalForm;
}

export default Vue.extend({
  name: 'Customers',
  components: {
    TopNav,
    NavItem,
    Status,
  },
  data(): LocalState {
    return {
      form: {
        search: '',
        selectedStatus: undefined,
        selectedProduct: undefined,
      },
      formLoaded: false,
      date: {
        startDate: new Date(),
        endDate: new Date(),
      },
      statuses: [
        {
          label: this.$t('CUSTOMERS.LABEL.ACTIVE'),
          code: true,
        },
        {
          label: this.$t('CUSTOMERS.LABEL.INACTIVE'),
          code: false,
        },
      ],
      tableFields: [
        {
          name: 'full_name',
          title: this.$t('ORDERS.TABLE.NAME'),
          cssClass: 'h5',
          ordering: 'first_name',
        },
        {
          key: 'email',
          title: this.$t('GENERAL.LABEL.EMAIL'),
          ordering: 'user__email',
        },
        {
          name: 'status',
          title: this.$t('CUSTOMERS.TABLE.STATUS'),
          ordering: 'status',
        },
        {
          name: 'total_spend',
          title: this.$t('CUSTOMERS.TABLE.LIFETIME_VALUE'),
          ordering: 'total_spend',
        },
        {
          name: 'last_time_purchase',
          title: this.$t('CUSTOMERS.TABLE.MOST_RECENT_PURCHASE'),
          ordering: 'last_time_purchase',
        },
        {
          name: 'signed_waiver',
          title: this.$t('CUSTOMERS.TABLE.SIGNED_WAIVER'),
          ordering: 'signed_waiver',
        },
        {
          name: 'has_notes',
          title: this.$t('PRODUCTS.TABLE.NOTES') as string,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      ordering: 'customer-list-table/orderingParam',
    }),
    config() {
      return getConfig();
    },
    query() {
      return {
        q: this.form.search,
        status: get(this.form.selectedStatus, 'code'),
        product: get(this.form.selectedProduct, 'id'),
      };
    },
    products() {
      return this.$store.state.product.teacherProducts || [];
    },
    customersStats() {
      return this.$store.state.sale.salesCustomersStats;
    },
    isLoading() {
      return !this.customersStats;
    },
    inactiveCustomers() {
      return (
        this.customersStats.all_customers - this.customersStats.active_customers
      );
    },
    activeCustomersPercentage() {
      if (!this.customersStats?.all_customers) {
        return 0;
      }
      return Math.round(
        (this.customersStats.active_customers /
          this.customersStats.all_customers) *
          100
      );
    },
    inactiveCustomersPercentage() {
      if (!this.customersStats?.all_customers) {
        return 0;
      }
      return Math.round(
        (this.inactiveCustomers / this.customersStats.all_customers) * 100
      );
    },
  },
  methods: {
    addCustomer() {
      this.$modal.show(
        AddCustomerFormModal,
        {},
        {},
        {
          finish: () => this.$refs['customer-list-table'].refresh(),
        }
      );
    },
    setStatusFilterValue(value) {
      this.form.selectedStatus = this.statuses.find(
        status => status.code === value
      );
    },
    openSendInvitationEmailsModal() {
      this.$modal.show(SendInvitationEmailsModal);
    },
    async exportCustomers() {
      const q = {
        ...this.query,
        ordering: this.ordering,
      };
      try {
        await this.$store.dispatch('sale/exportCustomers', q);
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_EXPORT_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.CUSTOMER_EXPORT_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
    async showNotes(student: ProductStudentCustomer) {
      this.$modal.show(CustomerNotesModal, {
        customerId: student.id,
      });
    },
  },
  async mounted() {
    const savedForm = await this.$store.dispatch(
      'filters/getFilter',
      'customer-list-table'
    );
    if (savedForm) {
      this.form = savedForm;
    }
    this.formLoaded = true;
    await Promise.all([
      this.$store.dispatch('sale/getSalesCustomersStats'),
      this.$store.dispatch('product/getTeacherProducts'),
    ]);
  },
  beforeDestroy() {
    this.$store.dispatch('filters/setFilter', {
      key: 'customer-list-table',
      filter: JSON.parse(JSON.stringify(this.form)),
    });
  },
});
